import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewDidLeave } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { LoadingService } from 'src/app/core/services/loading.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { VisualThemeModeService } from 'src/app/core/services/visual-theme-mode.service';
import { DetailService } from '../../services/detail.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-pick-device-type',
  templateUrl: './pick-device-type.component.html',
  styleUrls: ['./pick-device-type.component.scss']
})
export class PickDeviceTypeComponent extends BaseModal implements OnInit, ViewDidLeave {
  deviceCount: Array<{ DeviceName: string, DeviceCount: number }> = [];
  subs: Subscription
  constructor(private router: Router, private visualThemeModeService: VisualThemeModeService,
    private detailService: DetailService, private loadingService: LoadingService,
    private storageService: StorageService, private activatedRoute: ActivatedRoute,private modalService:ModalService) {
      super();
    super._modalService = modalService;
  }

  ionViewDidLeave(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
    this.deviceCount = [];
  }

  ngOnInit() {
   }

  later() {
    this.router.navigateByUrl("/common/later-page");
  }

  ionViewDidEnter() {

    this.subs = this.activatedRoute.queryParams.subscribe(res => {
      if (res["pair"]) {

      } else {
        this.getDeviceCount();
      }
    });
  }

  getDeviceCount() {
    this.loadingService.showLoading();
    this.detailService.getDeviceCount().subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.deviceCount = res.Data;
        if (this.deviceCount.filter(e => !e.DeviceName.includes("trap")).length > 0) {
          this.storageService.set(StorageKeys.FILIZ_DEMO, false);
        } else {
          this.storageService.set(StorageKeys.FILIZ_DEMO, true);
        }
        if (this.deviceCount.filter(e => e.DeviceName.includes("trap")).length > 0) {
          this.storageService.set(StorageKeys.TRAP_DEMO, false);
        } else {
          this.storageService.set(StorageKeys.TRAP_DEMO, true);
        }
      }
    });
  }


  selectDevice(i: number) {
    switch (i) {
      case 1:
        this.visualThemeModeService.setPesTrappTheme().subscribe(e => {
          if (this.deviceCount.filter(e => e.DeviceName.includes("trap")).length > 0) {
            this.router.navigate(["/pesttrapp/home"]);
          } else {
            this.router.navigate(["/common/pair-device"]);
          }
        });
        break;
      case 2:
        this.visualThemeModeService.setFilizTheme().subscribe(e => {
          if (this.deviceCount.filter(e => e.DeviceName == "filiz").length > 0) {
            this.router.navigate(["/filiz/home"]);
          } else {
            this.router.navigate(["/common/pair-device"]);
          }
        });
        break;
      default:
        break;
    }
  }

}
